import { UserContext } from '@providers/userContextProvider';
import dayjs from 'dayjs';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryBuilder } from '../utils';
import { NumberWidget } from './numberWidget';

const totalAumQuery = (activeOrganization: any) => ({
  filters: [
    {
      field: 'organization',
      comparison: 'EQUALS',
      value: activeOrganization.id,
    },
    {
      field: 'state',
      comparison: 'EQUALS',
      value: 'ACTIVE',
    },
    {
      field: 'marketValueCents',
      comparison: 'GREATER_THAN',
      value: '0',
    },
  ],
  type: 'SUB_ACCOUNT',
  grouping: {
    field: null,
    interval: null,
    type: 'SINGLE_VALUE',
    valueAggregation: 'SUM',
    valueField: 'marketValueCents',
  },
});

const historyAumQuery = (activeOrganization: any) => ({
  filters: [
    {
      field: 'organization',
      comparison: 'EQUALS',
      value: activeOrganization.id,
    },
    {
      field: 'date',
      comparison: 'GREATER_THAN_AGO',
      value: '35',
    },
    {
      field: 'marketValueCents',
      comparison: 'GREATER_THAN',
      value: '0',
    },
  ],
  type: 'DAILY_STATS',
  grouping: {
    valueField: 'marketValueCents',
    field: 'date',
    valueAggregation: 'SUM',
    type: 'FIRST_DATE_IN_INTERVAL',
    interval: 'DAY',
  },
  sorting: {
    sortField: 'date',
    sortDesc: true,
  },
});

export const TotalAum = () => {
  const { activeOrganization } = useContext(UserContext);
  const { t } = useTranslation('homePageConfiguration');
  const [historyAum, setHistoryAum] = useState<number>(0);
  const { data: totalAumData, loading: totalAumLoading } = useQueryBuilder(
    totalAumQuery(activeOrganization),
  );
  const { data: historyAumData, loading: historyAumLoading } = useQueryBuilder(
    historyAumQuery(activeOrganization),
  );

  const lastDayOfPreviousMonth = dayjs()
    .subtract(1, 'month')
    .endOf('month')
    .format('YYYY-MM-DD');

  useEffect(() => {
    if (historyAumData?.generateReport?.grouping) {
      const lastDayOfPreviousMonthAum =
        historyAumData?.generateReport?.grouping.find(
          (item: any) =>
            dayjs(item.key).format('YYYY-MM-DD') === lastDayOfPreviousMonth,
        );
      setHistoryAum(lastDayOfPreviousMonthAum?.value ?? 0);
    }
  }, [historyAumData, lastDayOfPreviousMonth]);

  return (
    <NumberWidget
      title={t('practiceOverview.totalAum')}
      newValue={(totalAumData?.generateReport?.grouping.value ?? 0) / 100}
      oldValue={historyAum / 100}
      loading={totalAumLoading || historyAumLoading}
    />
  );
};
